import * as React from "react";
const SvgFiBrandsTrello = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-trello_svg__a)">
      <path
        fill="#151A2D"
        fillRule="evenodd"
        d="M22.032.008H2.972c-.788 0-1.543.3-2.1.834A2.8 2.8 0 0 0 0 2.857v18.27c0 .754.313 1.492.866 2.026.55.53 1.328.84 2.106.84h19.06c.78 0 1.555-.312 2.103-.841A2.82 2.82 0 0 0 25 21.129V2.857a2.8 2.8 0 0 0-.87-2.013 3.03 3.03 0 0 0-2.098-.836m-11.25 17.275a.94.94 0 0 1-.294.675 1.02 1.02 0 0 1-.707.275H5.616a1 1 0 0 1-.697-.28.93.93 0 0 1-.289-.67v-11.9c0-.251.104-.492.289-.67.184-.178.435-.278.697-.28H9.78c.263 0 .513.1.698.279.186.178.29.419.29.67zm9.612-5.464a.93.93 0 0 1-.294.676c-.183.174-.45.277-.707.274h-4.166a1 1 0 0 1-.698-.28.94.94 0 0 1-.29-.67V5.384a.93.93 0 0 1 .29-.67c.186-.178.437-.278.698-.28h4.166c.261.002.512.103.697.28a.93.93 0 0 1 .288.67z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-trello_svg__a">
        <path fill="#fff" d="M0 0h25v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsTrello;
